import { Button } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { hideModal } from 'redux/modules/modal';
import { block } from './utils';

export interface ProjectPreviewModalRestoringButtonProps {}

const ProjectPreviewModalRestoringButton: React.FC<ProjectPreviewModalRestoringButtonProps> = () => {
  const dispatch = useDispatch();

  const handleHideModal = useCallback((): void => {
    dispatch(hideModal());
  }, [dispatch]);

  return (
    <Button
      variant="solid"
      className={block('got-it-button')}
      onPress={handleHideModal}
    >
      ok, got it
    </Button>
  );
};

export default ProjectPreviewModalRestoringButton;
